export function isMobileAndroid() {
    const isMobile = navigator.userAgent.includes('Mobile');
    const isAndroid = navigator.userAgent.includes('Android');
    return isMobile && isAndroid;
}
